import React from 'react';
import SignatureCanvas from 'react-signature-canvas';

export const DrawStaff = ({ sigCanvas, handleMouseDown, clearSignature }) => {
    return (
        <div className="signature-upload-draw-box">
            <div className="canvas-wrapper">
                <SignatureCanvas
                    ref={sigCanvas}
                    penColor="black"
                    canvasProps={{ width: 480, height: 100, className: 'sigCanvas' }}
                    onBegin={handleMouseDown}
                />
                <div className="canvas-line" />
                <div className="type-signature-actions">
                    <div style={{ width: '25%' }} />
                    <div style={{ width: '50%' }} />
                    <div style={{ width: '25%', textAlign: 'end' }}>
                        <button className="type-signature-clear-btn" onClick={clearSignature}>
                            Clear
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};
